export const ICON_STEP_1 = (
    <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="26.5"
            cy="26.5"
            r="25.5536"
            fill="white"
            stroke="#7B67FB"
            strokeWidth="1.89286"
        />
        <path
            d="M26.8214 5.67969C15.322 5.67969 6 15.0017 6 26.501C6 38.0004 15.322 47.3224 26.8214 47.3224C38.3207 47.3224 47.6427 38.0004 47.6427 26.501C47.6293 15.0073 38.3151 5.69307 26.8214 5.67969Z"
            fill="#7B67FB"
        />
        <path
            d="M29.9248 16.627V36.6247H25.6967V20.6402H25.5796L21 23.5109V19.7614L25.9506 16.627H29.9248Z"
            fill="white"
        />
    </svg>
);

export const ICON_STEP_2 = (
    <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="26.5"
            cy="26.5"
            r="25.5536"
            fill="white"
            stroke="#7B67FB"
            strokeWidth="1.89286"
        />
        <path
            d="M26.8214 5.67969C15.322 5.67969 6 15.0017 6 26.501C6 38.0004 15.322 47.3224 26.8214 47.3224C38.3207 47.3224 47.6427 38.0004 47.6427 26.501C47.6293 15.0073 38.3151 5.69307 26.8214 5.67969Z"
            fill="#7B67FB"
        />
        <path
            d="M19.6516 36.0892V32.9851L26.9043 26.2697C27.5211 25.6728 28.0384 25.1356 28.4563 24.658C28.8807 24.1805 29.2024 23.7129 29.4213 23.2553C29.6402 22.791 29.7496 22.2902 29.7496 21.753C29.7496 21.1561 29.6136 20.6421 29.3417 20.2109C29.0698 19.7732 28.6983 19.4383 28.2274 19.2061C27.7565 18.9674 27.2226 18.848 26.6257 18.848C26.0022 18.848 25.4584 18.974 24.9941 19.226C24.5298 19.4781 24.1717 19.8395 23.9196 20.3104C23.6676 20.7813 23.5416 21.3418 23.5416 21.9918H19.4526C19.4526 20.6586 19.7544 19.5013 20.358 18.5197C20.9615 17.5381 21.8072 16.7786 22.8949 16.2414C23.9826 15.7042 25.2362 15.4355 26.6555 15.4355C28.1147 15.4355 29.3848 15.6942 30.4659 16.2115C31.5536 16.7223 32.3993 17.4319 33.0028 18.3406C33.6064 19.2492 33.9082 20.2905 33.9082 21.4645C33.9082 22.2339 33.7556 22.9933 33.4505 23.7428C33.1521 24.4922 32.6181 25.3246 31.8488 26.2399C31.0794 27.1485 29.995 28.2396 28.5955 29.513L25.6209 32.428V32.5673H34.1768V36.0892H19.6516Z"
            fill="white"
        />
    </svg>
);

export const ICON_STEP_3 = (
    <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="26.5"
            cy="26.5"
            r="25.5536"
            fill="white"
            stroke="#7B67FB"
            strokeWidth="1.89286"
        />
        <path
            d="M26.8214 5.67969C15.322 5.67969 6 15.0017 6 26.501C6 38.0004 15.322 47.3224 26.8214 47.3224C38.3207 47.3224 47.6427 38.0004 47.6427 26.501C47.6293 15.0073 38.3151 5.69307 26.8214 5.67969Z"
            fill="#7B67FB"
        />
        <path
            d="M26.4833 37.2099C25.0299 37.2099 23.7354 36.9601 22.6 36.4605C21.471 35.9544 20.5788 35.2601 19.9235 34.3777C19.2746 33.4888 18.9405 32.4636 18.921 31.3022H23.1644C23.1904 31.7888 23.3494 32.217 23.6413 32.5869C23.9398 32.9502 24.3356 33.2325 24.8287 33.4336C25.3218 33.6348 25.8766 33.7353 26.493 33.7353C27.1354 33.7353 27.7031 33.6218 28.1962 33.3947C28.6893 33.1676 29.0754 32.8529 29.3544 32.4506C29.6334 32.0483 29.7729 31.5844 29.7729 31.0588C29.7729 30.5268 29.6237 30.0564 29.3252 29.6476C29.0332 29.2324 28.6115 28.9079 28.06 28.6744C27.5149 28.4408 26.8661 28.324 26.1134 28.324H24.2545V25.229H26.1134C26.7493 25.229 27.3105 25.1187 27.7972 24.8981C28.2903 24.6775 28.6731 24.3725 28.9456 23.9832C29.2181 23.5874 29.3544 23.1268 29.3544 22.6012C29.3544 22.1016 29.2344 21.6636 28.9943 21.2873C28.7607 20.9045 28.4298 20.606 28.0016 20.3919C27.5798 20.1778 27.0867 20.0707 26.5222 20.0707C25.9512 20.0707 25.4289 20.1745 24.9552 20.3822C24.4816 20.5833 24.102 20.872 23.8165 21.2484C23.531 21.6247 23.3786 22.0659 23.3591 22.572H19.3201C19.3395 21.4235 19.6672 20.4114 20.3031 19.5354C20.9389 18.6595 21.7954 17.975 22.8725 17.4818C23.956 16.9822 25.1791 16.7324 26.5417 16.7324C27.9172 16.7324 29.1208 16.9822 30.1525 17.4818C31.1841 17.9814 31.9855 18.6562 32.5564 19.5062C33.1339 20.3497 33.4194 21.297 33.4129 22.3481C33.4194 23.4642 33.0723 24.3952 32.3715 25.1414C31.6773 25.8876 30.7721 26.3612 29.6561 26.5624V26.7181C31.1225 26.9063 32.2385 27.4156 33.0041 28.2461C33.7763 29.0701 34.1591 30.1018 34.1526 31.3411C34.1591 32.4766 33.8314 33.4855 33.1696 34.3679C32.5143 35.2504 31.6091 35.9446 30.4542 36.4507C29.2992 36.9568 27.9756 37.2099 26.4833 37.2099Z"
            fill="white"
        />
    </svg>
);

export const ICON_STEP_4 = (
    <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="26.5"
            cy="26.5"
            r="25.5536"
            fill="white"
            stroke="#7B67FB"
            stroke-width="1.89286"
        />
        <path
            d="M26.8214 5.67969C15.322 5.67969 6 15.0017 6 26.501C6 38.0004 15.322 47.3224 26.8214 47.3224C38.3207 47.3224 47.6427 38.0004 47.6427 26.501C47.6293 15.0073 38.3151 5.69307 26.8214 5.67969Z"
            fill="#7B67FB"
        />
        <path
            d="M17.8258 32.222V29.7452L27.5026 15.8636H31.477V29.3708H34.1554V32.222H31.477V36.5996H28.2514V32.222H17.8258ZM28.3954 19.2044L21.5986 29.3708H28.3954V19.2044Z"
            fill="white"
        />
    </svg>
);

export const ICON_STEP_5 = (
    <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="26.5"
            cy="26.5"
            r="25.5536"
            fill="white"
            stroke="#7B67FB"
            stroke-width="1.89286"
        />
        <path
            d="M26.8214 5.67969C15.322 5.67969 6 15.0017 6 26.501C6 38.0004 15.322 47.3224 26.8214 47.3224C38.3207 47.3224 47.6427 38.0004 47.6427 26.501C47.6293 15.0073 38.3151 5.69307 26.8214 5.67969Z"
            fill="#7B67FB"
        />
        <path
            d="M31.765 18.4268H22.117V24.158C22.5202 23.6204 23.1154 23.1692 23.9026 22.8044C24.709 22.4396 25.5634 22.2572 26.4658 22.2572C28.0786 22.2572 29.3842 22.6028 30.3826 23.294C31.4002 23.9852 32.1202 24.8588 32.5426 25.9148C32.9842 26.9708 33.205 28.0844 33.205 29.2556C33.205 30.6764 32.9266 31.9436 32.3698 33.0572C31.8322 34.1516 31.0162 35.0156 29.9218 35.6492C28.8466 36.2828 27.5218 36.5996 25.9474 36.5996C23.8546 36.5996 22.1746 36.0812 20.9074 35.0444C19.6402 34.0076 18.8818 32.6348 18.6322 30.926H21.829C22.0402 31.8284 22.5106 32.5484 23.2402 33.086C23.9698 33.6044 24.8818 33.8636 25.9762 33.8636C27.3394 33.8636 28.357 33.4508 29.029 32.6252C29.7202 31.7996 30.0658 30.7052 30.0658 29.342C30.0658 27.9596 29.7202 26.9036 29.029 26.174C28.3378 25.4252 27.3202 25.0508 25.9762 25.0508C25.0354 25.0508 24.2386 25.2908 23.5858 25.7708C22.9522 26.2316 22.4914 26.8652 22.2034 27.6716H19.093V15.5468H31.765V18.4268Z"
            fill="white"
        />
    </svg>
);

export const ICON_DELETE = (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="40" height="40" rx="6" fill="#F3F6F9" />
        <path
            d="M20 11.25C20.6861 11.2499 21.3475 11.5063 21.8543 11.9689C22.3611 12.4314 22.6766 13.0667 22.739 13.75H27C27.19 13.7501 27.3729 13.8222 27.5118 13.952C27.6506 14.0817 27.7351 14.2593 27.748 14.4489C27.761 14.6385 27.7015 14.8259 27.5816 14.9733C27.4616 15.1207 27.2902 15.2171 27.102 15.243L27 15.25H26.417L25.15 26.23C25.0936 26.7174 24.86 27.167 24.4936 27.4934C24.1272 27.8198 23.6537 28.0001 23.163 28H16.837C16.3463 28.0001 15.8728 27.8198 15.5064 27.4934C15.14 27.167 14.9064 26.7174 14.85 26.23L13.582 15.25H13C12.8188 15.25 12.6437 15.1844 12.5071 15.0652C12.3705 14.9461 12.2816 14.7816 12.257 14.602L12.25 14.5C12.25 14.3188 12.3156 14.1437 12.4348 14.0071C12.5539 13.8705 12.7184 13.7816 12.898 13.757L13 13.75H17.261C17.3234 13.0667 17.6389 12.4314 18.1457 11.9689C18.6525 11.5063 19.3139 11.2499 20 11.25ZM18.5 17.5C18.255 17.5 18.05 17.655 18.008 17.859L18 17.938V24.063L18.008 24.141C18.05 24.345 18.255 24.5 18.5 24.5C18.745 24.5 18.95 24.345 18.992 24.141L19 24.062V17.939L18.992 17.859C18.95 17.656 18.745 17.5 18.5 17.5ZM21.5 17.5C21.255 17.5 21.05 17.655 21.008 17.859L21 17.938V24.063L21.008 24.141C21.05 24.345 21.255 24.5 21.5 24.5C21.745 24.5 21.95 24.345 21.992 24.141L22 24.062V17.939L21.992 17.859C21.95 17.656 21.745 17.5 21.5 17.5ZM20 12.75C19.395 12.75 18.89 13.18 18.775 13.75H21.225C21.109 13.18 20.605 12.75 20 12.75Z"
            fill="#7B67FB"
        />
    </svg>
);
